import {useSyncExternalStore} from 'react';
import {
  getSoftwareKeyboardSnapshot,
  subscribeToSoftwareKeyboard
} from '../lib/native/softwareKeyboard';

export function useSoftwareKeyboardVisible() {
  return useSyncExternalStore(
    subscribeToSoftwareKeyboard,
    getSoftwareKeyboardSnapshot,
    () => false
  );
}
